/**
 * Utility to detect if the current application context is the Admin Panel (Manage).
 * This logic should be consistent across App.tsx, interceptors, and components.
 */
export const isManageSubdomain = (): boolean => {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const search = window.location.search;

    // 1. Check for specific hostnames (production and development)
    if (
        hostname.startsWith('manage.') ||
        hostname.includes('manage-') ||
        hostname.includes('manage.localhost')
    ) {
        return true;
    }

    // 2. Check for local development flags/paths
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return (
            search.includes('admin=true') ||
            pathname.startsWith('/dashboard') ||
            pathname.startsWith('/admin') ||
            pathname.includes('/login') && search.includes('admin=true')
        );
    }

    // 3. Fallback check for paths in any environment
    return (
        pathname.startsWith('/admin') ||
        pathname.startsWith('/dashboard')
    );
};
